import {html} from '@isceco/widget-library2/external/lit'
import '@isceco/widget-library2/basic-elements/Title/Title'
import '@isceco/widget-library2/basic-elements/List/List.js'
import '@isceco/widget-library2/basic-elements/Filter/DateFilter'
import '@isceco/widget-library2/basic-elements/Filter/StringFilter.js'
import '@isceco/widget-library2/basic-elements/Filter/MultiselectFilter.js'
import WebComponent from '../../WebComponent.js'
import MonitoringDTO from "./MonitoringDTO";
import MonitoringColumns from "./MonitoringColumns";
import MonitoringService from "./MonitoringService";
import EnumDTO from "./EnumDTO";
import MonitoringColumnsRowVariant from "./MonitoringColumnsRowVariant";

export default class Monitoring extends WebComponent {
  constructor() {
    super()
    this.monitoringService = new MonitoringService()
  }

  get translationFile() {
    return './views/Monitoring/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.reload()
  }

  reload() {
    Promise.all([
      this.monitoringService.getBackendListUrl(),
      this.monitoringService.list('status'),
      this.monitoringService.isUserAllowed()
    ])
      .then(([url, statusList, isUserAllowed]) => {
        this.url = url
        this.statusList = statusList.map(json => new EnumDTO(json).toItem)
        this.isMonitoringAllowed = isUserAllowed
      })
      .catch(_ => {
        this.url = ''
        this.statusList = []
        this.isMonitoringAllowed = false
      })
      .finally(_ => {
        this.render()
      })
  }

  getTemplate() {
    if (!this.isMonitoringAllowed) {
      navigate({to: 'NotAuthorized'})
    }

    return html`
      <isceco-title id="page-title"
                    text="${this.i18n.translate('page.title')}"
      ></isceco-title>
      <isceco-filter-group>
        <isceco-date-filter label="${this.i18n.translate('table.header.monitoring.submission.time')}"
                            key="submissionTime"
                            minchars="0"
        ></isceco-date-filter>
        <isceco-string-filter label="${this.i18n.translate('table.header.monitoring.submitted.form')}"
                              key="submittedFormName"
                              minchars="0"
        ></isceco-string-filter>
        <isceco-string-filter label="${this.i18n.translate('table.header.monitoring.email')}"
                              key="email"
                              minchars="0"
        ></isceco-string-filter>
        <isceco-string-filter label="${this.i18n.translate('table.header.monitoring.form.uuid')}"
                              key="formUuid"
                              minchars="0"
        ></isceco-string-filter>
        <isceco-multiselect-filter label="${this.i18n.translate('table.header.monitoring.status')}"
                                   .items="${this.statusList}"
                                   key="status"
                                   minchars="0"
        ></isceco-multiselect-filter>
      </isceco-filter-group>
      <isceco-list url="${this.url}"
                   .i18n="${this.i18n}"
                   .dtoMapper="${this._toDTO}"
                   .columns="${MonitoringColumns.getColumns()}"
                   .rowVariant="${new MonitoringColumnsRowVariant()}"
                   sort="timestamp"
                   order="desc"
      ></isceco-list>
    `
  }

  _toDTO = row => new MonitoringDTO(row)
}
customElements.define('eform-frontend-monitoring', Monitoring)
